import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, Clock, ArrowRight, SquareArrowOutUpRight } from "lucide-react";
import BusinessLogo from "./BusinessLogo";
import { getBusinessLogoUrl } from "../utils/api";

export default function BusinessCard({ business }) {
  const hasLocation = Boolean(business.location);
  const logoCacheKey = useMemo(() => Date.now(), [business.id]);
  const logoBackdropUrl = useMemo(
    () => getBusinessLogoUrl(business.id, logoCacheKey),
    [business.id, logoCacheKey]
  );

  const handleLocationOpen = (e) => {
    if (!hasLocation) return;
    e.preventDefault();
    e.stopPropagation();
    window.open(business.location, "_blank", "noopener,noreferrer");
  };

  const handleLocationKeyDown = (e) => {
    if (!hasLocation) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      window.open(business.location, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Link to={`/business/${business.url_string}`} className="biz-card">
      {/* Card Header Gradient */}
      <div className="biz-card-header">
        <div
          className="biz-card-header-logo-blur"
          style={{ backgroundImage: `url(${logoBackdropUrl})` }}
          aria-hidden="true"
        />
        <BusinessLogo businessId={business.id} className="biz-card-logo" />
        <span className="biz-card-badge">{business.category}</span>
      </div>

      {/* Card Body */}
      <div className="biz-card-body">
        <h3 className="biz-card-name">{business.name}</h3>
        <p className="biz-card-desc">{business.description}</p>

        {/* Meta Info */}
        <div className="biz-card-meta">
          <div
            className={`biz-card-meta-item${hasLocation ? " biz-card-meta-item-clickable" : ""}`}
            onClick={handleLocationOpen}
            onKeyDown={handleLocationKeyDown}
            role={hasLocation ? "button" : undefined}
            tabIndex={hasLocation ? 0 : undefined}
            aria-label={hasLocation ? "Konumu yeni sekmede ac" : undefined}
          >
            <MapPin className="icon-white" />
            <span>{business.address}</span>
            {hasLocation && (
              <span>
                <SquareArrowOutUpRight className="icon-white" />
              </span>
            )}
          </div>
          <div className="biz-card-meta-item">
            <Clock className="icon-white" />
            <span>
              {business.workingHours.start} - {business.workingHours.end}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="biz-card-footer">
          <div className="biz-card-rating">
            {business.rating &&
              <>
                <Star className="rating-gold" />
                <span className="biz-card-rating-value text-gold">{Number(business.rating).toFixed(1)}</span>
                <span className="biz-card-rating-count">
                  ({business.reviewCount} değerlendirme)
                </span>
              </>
            }
          </div>
          <div className="biz-card-cta">
            Randevu Al
            <ArrowRight />
          </div>
        </div>
      </div>
    </Link>
  );
}
